import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-environments',
  standalone: true,
  templateUrl: './rt-icon-environments.component.html',
  styleUrls: ['./rt-icon-environments.component.scss']
})
export class RtIconEnvironmentsComponent {
  @Input() width: number | string = 24;
  @Input() height: number | string = 24;
}
